import { Ban, SearchX } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Card, Empty } from '@concours/ui'

export function NotFoundPage() {
  const { t } = useTranslation()
  return (
    <Card>
      <Empty
        icon={<SearchX aria-hidden="true" />}
        title={t('errors.notFound')}
        description={t('errors.notFoundText')}
        action={
          <Link className="btn btn-secondary" to="/">
            {t('errors.home')}
          </Link>
        }
      />
    </Card>
  )
}

/** Page 403, utilisée par <PermissionGuard forbidden={<ForbiddenPage />}>. */
export function ForbiddenPage() {
  const { t } = useTranslation()
  return (
    <Card>
      <Empty
        icon={<Ban aria-hidden="true" />}
        title={t('errors.forbidden')}
        description={t('errors.forbiddenText')}
        action={
          <Link className="btn btn-secondary" to="/">
            {t('errors.home')}
          </Link>
        }
      />
    </Card>
  )
}
